import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../../../store/views/entityView";
import { studyGroupsFilter } from "../../../../../../utils/entitiesFiltersUtils";
import { assignCourseToNmmApi, markCourseActiveApi, markCourseInactiveApi, unassignCourseFromNmmApi } from "../../../../../../store/redux/entities-action";
import Action from "../../../../actionsPopup/action/Action";
import ActionsPopup from "../../../../actionsPopup/ActionsPopup";
import classes from "./CourseMoreOptions.module.css";

const CourseMoreOptions = ({ course }) => {

  const dispatch = useDispatch();
  const { texts } = useSelector((state) => state.translate);
  const { userDetails } = useSelector((state) => state.auth);
  const schools = userDetails?.schools || [];
  const studyGroups = useSelector(state => selectEntitiesByFilters(state, studyGroupsFilter));

  const studyGroupsBySchool = useMemo(
    () =>
      studyGroups?.reduce((acc, group) => {
        const sid = group.schoolId;
        if (!sid)
          return acc;
        if (!acc[sid]) acc[sid] = [];
        acc[sid].push(group);
        return acc;
      }, {}),
    [studyGroups]
  );

  const markInactive = () => {
    dispatch(markCourseInactiveApi({ course }));
  }
  const assignToNmm = (nmmId) => {
    dispatch(assignCourseToNmmApi({ course, nmmId }))
  }
  const unassignFromNmm = () => {
    dispatch(unassignCourseFromNmmApi({ course, nmmId: course.nmmId }));
  };
  const markActive = () => {
    dispatch(markCourseActiveApi({ course }))
  }

  return (
    <ActionsPopup>
      {!course.tags?.includes("isInactive") && <Action text={texts.markAsInactive} onClick={markInactive} />}
      {course.tags?.includes("isInactive") && !course.oldCourse && <Action text={texts.markAsActive} onClick={markActive} />}
      {course.nmmId && <Action text={texts.unassignStudyGroup} onClick={unassignFromNmm} />}
      {!course.oldCourse &&
        <Action text={!course.nmmId ? texts.assignSyudyGroup : texts.changeStudyGroup}>
          {schools?.map((school) =>
            <Action key={school.id} text={school.name}>
              {studyGroupsBySchool[school.id]?.length > 0 ? <Action key={`title-${school.id}`} text={texts.yourStudyGroups} isTitle /> : ""}
              {studyGroupsBySchool[school.id]?.filter((group) => group.id !== course.nmmId)?.map((group, index) => <Action key={index} text={group.name} onClick={() => assignToNmm(group.id)} />)}
            </Action>
          )}
        </Action>
      }
    </ActionsPopup>
  );
};

export default CourseMoreOptions;
